import $ from "jquery";

const collapseContentByClick = () => {
  const init = () => {
    toggleCollapse();
  };

  const toggleCollapse = () => {
    const el = {
      button: ".js-solution-collapse-content",
      list: ".js-solution-collapse-content--hidden",
    };

    if ($(el.button).length === 0) return;
    const showList = 4;

    $(el.list).each(function () {
      $(this).find("li").slice(showList).hide();
    });

    $(document).on("click", el.button, function (e) {
      e.preventDefault();
      const dataTo = $(this).data("to");

      $(`${dataTo} li`).slice(showList).toggle(300);
      $(this)
        .find("i")
        .css("transform", function (i, val) {
          return val === "matrix(1, 0, 0, -1, 0, 0)"
            ? "scaleY(1)"
            : "scaleY(-1)";
        });
    });
  };

  init();
};

try {
  collapseContentByClick();
} catch (error) {
  console.error(error);
}
